export const taskPlaceholderMixin = `
  relative
  box-content
  w-full

  before:content-[""]
  before:absolute
  before:top-0
  before:bottom-0
  before:left-0
  before:right-0
  before:rounded-8
  before:[opacity:0.56]
  before:bg-background-hover

  after:content-[""]
  after:absolute
  after:top-[4.5px]
  after:bottom-[4.5px]
  after:left-[4.5px]
  after:right-[4.5px]
  after:border-1
  after:border-dashed
  after:border-action-hover
  after:rounded-4
`
